<template>
    <div class="mt-2" v-if="field && ready">
        <component :is="`identity-field-custom-template-${this.scope}`" :field="field" v-model="val" :context="context" :page="page">
            <template #DefaultField="fieldProps" >
                <div> <slot name="DefaultField" v-bind="fieldProps"></slot> </div>
            </template>
        </component>
    </div>

    <b-alert :show="errorModal.show" variant="danger" v-else-if="!ready">
        {{ errorModal.msg }}
    </b-alert>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
//import { Builder } from 'protokol-sdk'
import Runner from '@/components/renderer/runner'

export default {
    name: 'CustomTemplate',
    components: {},
    props: {
        content: {
            type: String
        },

        field: {
            type: Object
        },

        context: {
            type: Object
        },

        value: {
            type: null
        },

        page: {
            type: String
        }
    },

    data: function() {
        return {
            scope: null,
            ready: false,
            errorModal: {
                show: false,
                msg: null
            },
        }
    },

    methods: {
        isCustomTemplate() {
            return this.template != ''
        },

        showErrorModal(msg) {
            this.errorModal.show = true;
            this.errorModal.msg = msg;
        },

        displayError(message) {
            this.$notify({
                group: 'system',
                type: 'error',
                position: 'right',
                text: message
            })
        },


    libs() {
            return {
                moment: moment,
                lodash: _,
                console: console,
                exports: {}
            }
        },

        runJS(script, vars) {
            try {
                const b = {
                    ...vars, 
                    ...this.libs()
                }

                return new Runner().runJS(script, b)
            } catch(err) {
                console.error(err)
                this.showErrorModal(err.message)
            }
        },
    },
    
    computed: {
        val: {
            get() {
                return this.value
            },

            set(val) {
                this.$emit('input', val)
            }
        },

        template() {
            if (this.content == '' || !this.content) {
                return  `<template>
                        <div>
                            <slot name="DefaultField"></slot>
                        </div>
                    </template>

                    <script>
                    export default {}
                    <\/script>`
            }

            return this.content
        }
    },

    async created() {
        this.scope = (Math.random() + 1).toString(36).substring(7)

        try {
            // let builder = new Builder(4, 'vue2')
            // let contents = await builder.build({
            //     'index.vue': this.template
            // })

            // let result = contents['index.vue']

            // const jsEvalResult = this.runJS(result.script)
            // if (jsEvalResult && jsEvalResult.stack && jsEvalResult.message) {
            //     this.showErrorModal(`
            //         ${jsEvalResult.message}
            //         ----
            //         ${jsEvalResult.stack}
            //     `)
            //     return
            // }
        
            // if sdk 4 didn't rendered anything then we try to render it with sdk 5
            // TODO: deprecated this after all templates are migrated to sdk 5
            // if (result.template == '') {
            //     builder = new Builder(5, 'vue2')
            //     let contents = await builder.build({
            //         'index.vue': this.template
            //     })

            //     result = contents['index.vue']

            //     let component = {
            //         ...jsEvalResult,
            //         name: `CustomTemplate${this.scope}`,
            //         render: new Function(result.render),
            //         staticRenderFns: result.staticRenderFns.map(f => {
            //             return new Function(f)
            //         }),
            //         props: ['value','field','context','page'],
            //         mixins: [{
            //             computed: {
            //                 isEditPage() {
            //                     return this.page == 'model_edit'
            //                 }
                            
            //             }
            //         }]
            //     }

            //     this.$options.components[`identity-field-custom-template-${this.scope}`] = component

            //     this.ready = true

            //     return
            // }

            // let component = {
            //     ...jsEvalResult,
            //     name: `CustomTemplate${this.scope}`,
            //     props: ['value','field','context','page'],
            //     template: result.template,
            //     mixins: [{
            //         computed: {
            //             isEditPage() {
            //                 return this.page == 'model_edit'
            //             }
                        
            //         }
            //     }]
            // }

            // this.$options.components[`identity-field-custom-template-${this.scope}`] = component

            this.ready = true
        } catch(err) {
            this.$debugLog(err)
            this.showErrorModal(err.message)
        }
    }
}
</script>